import { faGlobeAmericas } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { lightBlue } from '@mui/material/colors';
import { computed, makeObservable } from 'mobx';
import { inject, observer } from 'mobx-react';
import Configuracao from '../util/Configuracao';
import ReactComponent from './ReactComponent';

class IconeConsultaPublica extends ReactComponent {
    static TAMANHO_PADRAO = 14;
    static COR_HOVER_PADRAO = lightBlue[900];

    constructor(props) {
        super(props);

        makeObservable(this, {
            registro: computed,
            linkConsultaPublica: computed
        });
    }

    get registro() {
        return this.observableProps.registro;
    }

    get linkConsultaPublica() {
        return (
            this.registro &&
            this.registro.detalhes &&
            this.registro.detalhes.links &&
            this.registro.detalhes.links.find((link) => link.id === 'consultaProcessual')
        );
    }

    handleClickIcone = () => {
        window.open(this.linkConsultaPublica.uri.replace(/&amp;/g, '&'));
    };

    render() {
        if (this.registro.processo.origem === Configuracao.ORIGEM_PJE || !this.linkConsultaPublica) {
            return null;
        }

        return (
            <Box sx={{ ml: 1, cursor: 'pointer' }}>
                <IconButton
                    onClick={this.handleClickIcone}
                    size="small"
                    sx={{
                        '&:hover': {
                            color: this.observableProps.hover
                                ? this.observableProps.hover
                                : IconeConsultaPublica.COR_HOVER_PADRAO
                        }
                    }}
                >
                    <Tooltip title={<Typography>Abrir consulta pública</Typography>}>
                        <FontAwesomeIcon icon={faGlobeAmericas} />
                    </Tooltip>
                </IconButton>
            </Box>
        );
    }
}

export default inject('stores')(observer(IconeConsultaPublica));
